import React from "react";

const MDXContent = ({ children }) => {
  return <>{children}</>;
};

export default MDXContent;
